"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _rcUpload = _interopRequireDefault(require("rc-upload"));
var React = _interopRequireWildcard(require("react"));
var _StyledButton = _interopRequireDefault(require("../Button/StyledButton"));
var _default2 = _interopRequireDefault(require("../locales/default"));
var _LocaleContext = require("../locales/LocaleContext");
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledUpload = require("./StyledUpload");
var _UploadList = _interopRequireDefault(require("./UploadList"));
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Upload = /*#__PURE__*/function (_React$Component) {
  //: any;
  function Upload(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Upload);
    _this = _callSuper(this, Upload, [props]);
    (0, _defineProperty2.default)(_this, "recentUploadStatus", void 0);
    //: boolean | PromiseLike<any>;
    (0, _defineProperty2.default)(_this, "progressTimer", void 0);
    // : any;
    (0, _defineProperty2.default)(_this, "upload", void 0);
    (0, _defineProperty2.default)(_this, "clearItems", function () {
      _this.setState({
        fileList: []
      });
    });
    (0, _defineProperty2.default)(_this, "onStart", function (file) {
      var targetItem;
      var nextFileList = _this.state.fileList.concat();
      targetItem = (0, _utils.fileToObject)(file);
      targetItem.status = 'uploading';
      nextFileList.push(targetItem);
      _this.onChange({
        file: targetItem,
        fileList: nextFileList
      });
      // fix ie progress
      if (!window.FormData) {
        _this.autoUpdateProgress(0, targetItem);
      }
    });
    (0, _defineProperty2.default)(_this, "onSuccess", function (response, file) {
      _this.clearProgressTimer();
      try {
        if (typeof response === 'string') {
          response = JSON.parse(response);
        }
      } catch (e) {
        /* do nothing */
      }
      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.getFileItem)(file, fileList);
      // removed
      if (!targetItem) {
        return;
      }
      targetItem.status = 'done';
      targetItem.response = response;
      _this.onChange({
        file: _objectSpread({}, targetItem),
        fileList: fileList
      });
    });
    (0, _defineProperty2.default)(_this, "onProgress", function (e, file) {
      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.getFileItem)(file, fileList);
      // removed
      if (!targetItem) {
        return;
      }
      targetItem.percent = e.percent;
      _this.onChange({
        event: e,
        file: _objectSpread({}, targetItem),
        fileList: _this.state.fileList
      });
    });
    (0, _defineProperty2.default)(_this, "onError", function (error, response, file) {
      _this.clearProgressTimer();
      var fileList = _this.state.fileList;
      var targetItem = (0, _utils.getFileItem)(file, fileList);
      // removed
      if (!targetItem) {
        return;
      }
      targetItem.error = error;
      targetItem.response = response;
      targetItem.status = 'error';
      _this.onChange({
        file: _objectSpread({}, targetItem),
        fileList: fileList
      });
    });
    (0, _defineProperty2.default)(_this, "handleManualRemove", function (file) {
      _this.upload.abort(file);
      file.status = 'removed'; // eslint-disable-line
      _this.handleRemove(file);
    });
    (0, _defineProperty2.default)(_this, "onChange", function (info) {
      if (!('fileList' in _this.props)) {
        _this.updateFileList(info.fileList);
      }
      var onChange = _this.props.onChange;
      if (onChange) {
        onChange(info);
      }
    });
    (0, _defineProperty2.default)(_this, "onFileDrop", function (e) {
      _this.setState({
        dragState: e.type
      });
    });
    (0, _defineProperty2.default)(_this, "beforeUpload", function (file, fileList) {
      var _this$internalFileLis;
      if (_this.props.maxCount && _this.props.maxCount <= ((_this$internalFileLis = _this.internalFileList) === null || _this$internalFileLis === void 0 ? void 0 : _this$internalFileLis.length)) {
        _this.upload.abort(file);
        return false;
      }
      var targetItem = (0, _utils.fileToObject)(file);
      _this.internalFileList = [].concat((0, _toConsumableArray2.default)(_this.internalFileList), [targetItem]);
      if (!_this.props.beforeUpload) {
        return true;
      }
      var result = _this.props.beforeUpload(file, fileList);
      if (result === false) {
        _this.onChange({
          file: file,
          fileList: (0, _uniqBy.default)(fileList.map(_utils.fileToObject).concat(_this.state.fileList), function (item) {
            return item.uid;
          })
        });
        return false;
      } else if (result && result.then) {
        return result;
      }
      return true;
    });
    (0, _defineProperty2.default)(_this, "saveUpload", function (node) {
      _this.upload = node;
    });
    (0, _defineProperty2.default)(_this, "renderUploadList", function (localeCode, locale) {
      var _this$props = _this.props,
        showUploadList = _this$props.showUploadList,
        listType = _this$props.listType,
        onPreview = _this$props.onPreview,
        disabled = _this$props.disabled;
      var showRemoveIcon = showUploadList.showRemoveIcon,
        showPreviewIcon = showUploadList.showPreviewIcon;
      return /*#__PURE__*/React.createElement(_UploadList.default, {
        listType: listType,
        items: _this.state.fileList,
        onPreview: onPreview,
        onRemove: _this.handleManualRemove,
        showRemoveIcon: !disabled && showRemoveIcon,
        showPreviewIcon: showPreviewIcon,
        locale: _objectSpread(_objectSpread({}, locale), _this.props.locale)
      });
    });
    (0, _defineProperty2.default)(_this, "renderUploadButtonDefault", function (localeCode, locale) {
      var _this$props$prefixCls = _this.props.prefixCls,
        prefixCls = _this$props$prefixCls === void 0 ? '' : _this$props$prefixCls;
      if (_this.props.type === 'drag') {
        return /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
          return /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadDragInfo, {
            className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-drag-info"), !!prefixCls)),
            theme: theme
          }, /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadIcon, {
            $theme: theme,
            name: "upload"
          }), /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadText, {
            className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-text"), !!prefixCls)),
            theme: theme
          }, locale.dragText), /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadLink, {
            theme: theme,
            className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-link"), !!prefixCls)),
            link: "#",
            onClick: function onClick(e) {
              return e.preventDefault();
            }
          }, locale.dragLinkText));
        });
      }
      return /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/React.createElement(_StyledButton.default, {
          theme: theme,
          type: "secondary"
        }, /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadIcon, {
          $theme: theme,
          name: "upload"
        }), " Upload");
      });
    });
    _this.state = {
      fileList: props.fileList || props.defaultFileList || [],
      dragState: 'drop'
    };
    _this.internalFileList = props.fileList || props.defaultFileList || [];
    _this.sanitizeEndpoint = _this.sanitizeEndpoint.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(Upload, _React$Component);
  return (0, _createClass2.default)(Upload, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearProgressTimer();
    }
  }, {
    key: "autoUpdateProgress",
    value: function autoUpdateProgress(_, file) {
      var _this2 = this;
      var getPercent = (0, _utils.genPercentAdd)();
      var curPercent = 0;
      this.clearProgressTimer();
      this.progressTimer = setInterval(function () {
        curPercent = getPercent(curPercent);
        _this2.onProgress({
          percent: curPercent * 100
        }, file);
      }, 200);
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(file) {
      var _this3 = this;
      var onRemove = this.props.onRemove;
      Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
        // Prevent removing file
        if (ret === false) {
          return;
        }
        var removedFileList = (0, _utils.removeFileItem)(file, _this3.state.fileList);
        if (removedFileList) {
          _this3.onChange({
            file: file,
            fileList: removedFileList
          });
        }
      });
    }
  }, {
    key: "updateFileList",
    value: function updateFileList(fileList) {
      this.setState({
        fileList: fileList || []
      });
      this.internalFileList = fileList || [];
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if ('fileList' in nextProps) {
        this.updateFileList(nextProps.fileList);
      }
    }
  }, {
    key: "clearProgressTimer",
    value: function clearProgressTimer() {
      clearInterval(this.progressTimer);
    }
  }, {
    key: "sanitizeEndpoint",
    value: function sanitizeEndpoint(endpoint) {
      return endpoint.charAt(0) !== '/' ? '/' + endpoint : endpoint;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props2 = this.props,
        _this$props2$prefixCl = _this$props2.prefixCls,
        prefixCls = _this$props2$prefixCl === void 0 ? '' : _this$props2$prefixCl,
        className = _this$props2.className,
        showUploadList = _this$props2.showUploadList,
        listType = _this$props2.listType,
        type = _this$props2.type,
        disabled = _this$props2.disabled,
        endpoint = _this$props2.endpoint,
        action = _this$props2.action,
        heightUpload = _this$props2.heightUpload;
      var bffUrl = action;
      if (endpoint) {
        if (process.env.NODE_ENV === 'development' && typeof process.env.REACT_APP_API_LOCAL_URL !== 'undefined') {
          bffUrl = "".concat(process.env.REACT_APP_API_LOCAL_URL).concat(this.sanitizeEndpoint(endpoint));
        } else {
          bffUrl = "".concat(process.env.REACT_APP_GATEWAY_BFF, "/").concat(process.env.REACT_APP_API_NAME).concat(this.sanitizeEndpoint(endpoint));
        }
      }
      var rcUploadProps = _objectSpread(_objectSpread({
        onStart: this.onStart,
        onError: this.onError,
        onProgress: this.onProgress,
        onSuccess: this.onSuccess
      }, this.props), {}, {
        beforeUpload: this.beforeUpload,
        headers: _objectSpread(_objectSpread({}, this.props.headers), {}, {
          'x-hmn-sessionid': window.hmnSessionId || 'NA'
        }),
        action: bffUrl
      });
      delete rcUploadProps.className;
      var uploadList = showUploadList ? /*#__PURE__*/React.createElement(_LocaleContext.LocaleReceiver, {
        componentName: "Upload",
        defaultLocale: _default2.default.Upload
      }, this.renderUploadList) : null;
      var uploadContent = rcUploadProps.children ? rcUploadProps.children : /*#__PURE__*/React.createElement(_LocaleContext.LocaleReceiver, {
        componentName: "Upload",
        defaultLocale: _default2.default.Upload
      }, this.renderUploadButtonDefault);
      var classNameRightList = listType == 'right-list' ? {
        display: 'flex',
        height: '170px'
      } : listType == 'right-list-2' || listType == 'right-list-3' ? {
        display: 'flex',
        height: heightUpload
      } : {};
      if (type === 'drag') {
        return /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
          return /*#__PURE__*/React.createElement(_StyledUpload.RightListWrapper, {
            className: className,
            style: classNameRightList,
            $listType: listType,
            $heightUpload: heightUpload
          }, /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadWrapper, {
            prefixCls: prefixCls
          }, function (containerPrefix) {
            return /*#__PURE__*/React.createElement(_StyledUpload.StyledUpload, {
              className: (0, _classnames.default)(containerPrefix, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(containerPrefix, "-drag"), true), "".concat(containerPrefix, "-drag-uploading"), _this4.state.fileList.some(function (file) {
                return file.status === 'uploading';
              })), "".concat(containerPrefix, "-drag-hover"), _this4.state.dragState === 'dragover'), "".concat(containerPrefix, "-disabled"), disabled)),
              theme: theme,
              $disabled: disabled,
              $hover: _this4.state.dragState === 'dragover',
              $listType: listType,
              onDrop: _this4.onFileDrop,
              onDragOver: _this4.onFileDrop,
              onDragLeave: _this4.onFileDrop,
              prefixCls: containerPrefix,
              $heightUpload: heightUpload
            }, /*#__PURE__*/React.createElement(_rcUpload.default, (0, _extends2.default)({}, rcUploadProps, {
              style: _objectSpread(_objectSpread({}, rcUploadProps.style), {}, {
                height: rcUploadProps.height
              }),
              ref: _this4.saveUpload,
              className: "".concat(containerPrefix, "-btn"),
              prefixCls: containerPrefix
            }), /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadDragContainer, {
              $listType: listType,
              className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(containerPrefix, "-drag-container"), true)),
              theme: theme
            }, uploadContent)));
          }), uploadList);
        });
      }
      var uploadButton = /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadWrapper, {
          prefixCls: prefixCls
        }, function (containerPrefix) {
          return /*#__PURE__*/React.createElement(_StyledUpload.StyledUpload, {
            className: (0, _classnames.default)(containerPrefix, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(containerPrefix, "-select"), true), "".concat(containerPrefix, "-select-").concat(listType), true), "".concat(containerPrefix, "-disabled"), disabled)),
            theme: theme,
            $disabled: disabled,
            style: {
              display: uploadContent ? '' : 'none'
            }
          }, /*#__PURE__*/React.createElement(_rcUpload.default, (0, _extends2.default)({}, rcUploadProps, {
            ref: _this4.saveUpload,
            prefixCls: containerPrefix
          }), uploadContent));
        });
      });
      if (listType === 'picture-card') {
        return /*#__PURE__*/React.createElement("div", {
          className: className
        }, uploadList, uploadButton);
      }
      return /*#__PURE__*/React.createElement(_StyledUpload.StyledUploadButtonContainer, {
        className: className
      }, uploadButton, uploadList);
    }
  }]);
}(React.Component);
Upload.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  prefixCls: _propTypes.default.string,
  type: _propTypes.default.oneOf(['drag', 'select']),
  multiple: _propTypes.default.bool,
  action: _propTypes.default.string,
  data: _propTypes.default.object,
  accept: _propTypes.default.string,
  beforeUpload: _propTypes.default.func,
  showUploadList: _propTypes.default.bool,
  listType: _propTypes.default.oneOf(['text', 'picture', 'right-list', 'right-list-2', 'right-list-3']),
  disabled: _propTypes.default.bool,
  supportServerRender: _propTypes.default.bool,
  directory: _propTypes.default.bool,
  endpoint: _propTypes.default.string,
  maxCount: _propTypes.default.number,
  heightUpload: _propTypes.default.string
};
Upload.defaultProps = {
  prefixCls: 'ykb-ui-upload',
  type: 'select',
  // or drag
  multiple: false,
  action: '',
  data: {},
  accept: '',
  beforeUpload: _utils.T,
  showUploadList: true,
  listType: 'text',
  // or picture
  className: '',
  disabled: false,
  supportServerRender: true,
  directory: false,
  heightUpload: ''
};
var Dragger = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Upload, (0, _extends2.default)({}, props, {
    type: "drag",
    ref: ref
  }));
});
Upload.Dragger = Dragger;
var _default = exports.default = Upload;